import { SectionHeader } from "../SectionHeader";

import { IPinCodeInputViewProps } from "./PinCodeInput";

import backspaceIcon from "../../assets/images/backspace-icon.png";

function PinDisplayField({
  isFocused,
  fieldValue,
}: {
  isFocused: boolean;
  fieldValue: string;
}) {
  return (
    <div
      style={{
        ...styles.pinDisplayField,
        borderColor: isFocused ? "rgb(59, 120, 255)" : "#70707040",
      }}
    >
      {/* <div style={styles.pinDisplayFieldText}>{fieldValue}</div> */}
      <div
        style={{
          ...styles.pinDisplayFieldText,
          backgroundColor: !fieldValue ? "transparent" : "rgb(59, 120, 255)",
        }}
      />
    </div>
  );
}

function PinInputField({
  keyValue,
  disabled,
  style,
  padded,
  isDeleteKey,
  handlePinDelete,
  handlePinInput,
}: {
  keyValue: string;
  disabled?: boolean;
  style?: any;
  padded?: boolean;
  isDeleteKey?: boolean;
  handlePinDelete: () => void;
  handlePinInput: (pin: string) => void;
}) {
  return (
    <button
      // style={styles.pinInputField}
      onClick={() =>
        !disabled &&
        (isDeleteKey ? handlePinDelete() : handlePinInput(keyValue))
      }
      className={`pin-input--button justify-content--center align-items--center ${
        padded ? "padded-input" : ""
      }`}
      type="button"
    >
      {isDeleteKey ? (
        <img
          src={backspaceIcon}
          alt="SwitchApp logo"
          className="backspace-icon"
        />
      ) : (
        <span style={{ ...styles.pinInputFieldText, ...style }}>
          {keyValue}
        </span>
      )}
    </button>
  );
}

export function View(props: IPinCodeInputViewProps) {
  const {
    title,
    subtitle,
    // buttonText,
    pin,
    pinCodeLength,
    pinInputErrorMessage,
    showPinValues,

    handlePinInput,
    handlePinDelete,
    // handlePinSubmit,
  } = props;

  return (
    <div className="pin-input--container flex-container col justify-content--center">
      <div className="flex-container justify-content--center align-items--center mt-5">
        <SectionHeader
          title={title}
          subtitle={subtitle}
          subtitleClassName="align-text--center"
        />
      </div>

      <div className="flex-container col justify-content--center">
        <div className="pin-value--container flex-container justify-content--center align-items--center">
          <div className="pin-value--display flex-container justify-content--center align-items--center">
            {Array(pinCodeLength)
              .fill(0)
              .map((_, i) => {
                const pinIndex = i; // right-to-left

                return (
                  <div
                    key={pinIndex}
                    className="flex-container justify-content--center align-items--stretch"
                  >
                    <PinDisplayField
                      key={pinIndex}
                      isFocused={pin.length === pinIndex}
                      fieldValue={
                        pin[pinIndex]
                          ? showPinValues
                            ? pin[pinIndex]
                            : "*"
                          : ""
                      }
                    />
                  </div>
                );
              })}
          </div>
        </div>

        <div className="flex-container justify-content--center align-items--center mb-5">
          <span style={styles.errorText}>{pinInputErrorMessage}</span>
        </div>

        <div className="flex-container col justify-content--center">
          <div className="button-row flex-container justify-content--center align-items--center">
            <PinInputField
              keyValue={"1"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
            />
            <PinInputField
              keyValue={"2"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
              padded
            />
            <PinInputField
              keyValue={"3"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
            />
          </div>

          <div className="button-row flex-container justify-content--center align-items--center">
            <PinInputField
              keyValue={"4"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
            />
            <PinInputField
              keyValue={"5"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
              padded
            />
            <PinInputField
              keyValue={"6"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
            />
          </div>

          <div className="button-row flex-container justify-content--center align-items--center">
            <PinInputField
              keyValue={"7"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
            />
            <PinInputField
              keyValue={"8"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
              padded
            />
            <PinInputField
              keyValue={"9"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
            />
          </div>

          <div className="button-row flex-container justify-content--center align-items--center">
            <PinInputField
              keyValue={"."}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
              disabled
            />
            <PinInputField
              keyValue={"0"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
              padded
            />
            <PinInputField
              keyValue={"<"}
              handlePinInput={handlePinInput}
              handlePinDelete={handlePinDelete}
              isDeleteKey
              style={styles.deleteButton}
            />
          </div>

          {/* Auto-submit on complete enabled */}
          {/* {!handlePinSubmit ? null : (
            <div className="flex-container row justify-content--center mt-5">
              <SwitchAppButton className="" onClick={handlePinSubmit}>
                {buttonText || "SUBMIT PIN"}
              </SwitchAppButton>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    flex: 1,
    justifyContent: "center",
  },
  pinInputComponentsContainer: {
    flex: 1,
    // justifyContent: "center",
  },
  pinDisplayContainer: {
    // flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  pinDisplayFieldContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "stretch",

    // borderColor: "blue",
    // borderWidth: 1,
  },
  pinDisplayField: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 5,
    marginLeft: 5,
    marginRight: 5,
    minHeight: 30,
    minWidth: 30,
    border: "2px solid",
    backgroundColor: "#e2e2e4",
    borderRadius: "100%",
  },
  pinDisplayFieldText: {
    padding: 10,
    borderRadius: "100%",
    // fontSize: 25,
    // fontWeight: "bold",
    // color: "#000",
  },
  pinInputContainer: {
    flex: 1,
    justifyContent: "center",

    // borderColor: "red",
    // borderWidth: 1,
  },
  pinInputRowContainer: {
    flex: 1,
    // flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: 0,
    maxHeight: 80,

    // borderColor: "orange",
    // borderWidth: 1,
  },
  pinInputField: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: "5%",

    // borderColor: "green",
    // borderWidth: 1,
  },
  pinInputFieldText: {
    fontSize: 30,
    fontWeight: "bold",
  },
  pinErrorContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 10,

    // borderColor: "purple",
    // borderWidth: 1,
  },
  errorText: {
    fontSize: 16,
    fontWeight: "bold",
    color: "red",
  },
  button: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 30,
  },
  buttonText: {
    fontSize: 12,
    fontWeight: "bold",
  },
  deleteButton: {
    fontSize: 20,
    alignSelf: "center",
    paddingVertical: 5,
  },
};
